import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = Pick<OpalApiRequestParams<'NotifyMomentCustomFieldV3'>, 'path'>
type RequestBody = OpalApiRequestBody<'NotifyMomentCustomFieldV3'>
type Response = OpalApiResponseDocument<'NotifyMomentCustomFieldV3', 200>

export const notifyMomentCustomField = ({
  params,
  requestBody = {},
}: {
  params: Params
  requestBody?: RequestBody
}) => {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}/moment_custom_fields/${params.path.moment_custom_field_id}/do/notify`,
    window.location.origin
  )

  return HttpClient()
    .post<Response>(url.toString(), requestBody)
    .then((res) => res.data)
}
